module.exports = __webpack_public_path__ + "static/media/ic_sidemenu_catalogue.7895c6f2.svg";